import 'whatwg-fetch';
import { api, jumboQAtransbank } from 'config';
import StorageService from 'services/StorageService';
import LoginService from 'services/Login';

const getAccount = () => {
    const token = LoginService.getUserToken();

    const headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'token': token,
        'cache-control': 'no-cache',
        'Content-Type': 'application/json'
    }

    if (jumboQAtransbank) {
        Object.assign(headers, {'x-consumer': 'jumboQA'})
    }

    return fetch(api.wallet + `/wiretransfer/account`, {
        method: 'GET',
        headers
    }).then(data => data.json());
}

const deleteAccount = () => {
    const token = LoginService.getUserToken();
    const headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'token': token,
        'cache-control': 'no-cache',
        'Content-Type': 'application/json'
    }

    if (jumboQAtransbank) {
        Object.assign(headers, {'x-consumer': 'jumboQA'})
    }

    return fetch(api.wallet + `/wiretransfer/account`, {
        method: 'DELETE',
        headers
    }).then(data => data.json());
}

const addAccount = (bankCode, accountNumber, accountType , nameTitular, document) => {
    const token = LoginService.getUserToken();
    const userData = StorageService.getSecureItem('userData');
    const headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'token': token,
        'cache-control': 'no-cache',
        'Content-Type': 'application/json'
    }

    if (jumboQAtransbank) {
        Object.assign(headers, {'x-consumer': 'jumboQA'})
    }

    let payload = {
        "userFirstName": userData.firstName,
        "userLastName": userData.lastName, 
        "bankCode": bankCode,
        "accountNumber": accountNumber,
        "accountType": accountType,
        "accountTitular": nameTitular,
        "documentTitular": document
    }

    return fetch(api.walletV2 + `/wiretransfer/account`, {
        method: 'POST',
        headers,
        body: JSON.stringify(payload)
    }).then(data => data.json());
}

const listBank = () => {
    const token = LoginService.getUserToken();

    return fetch(api.wallet + `/wiretransfer/banks`, {
        method: 'GET',
        headers: {
            'x-api-key': api.apiKey,
            'pragma': 'no-cache',
            'token': token,
            'cache-control': 'no-cache',
            'Content-Type': 'application/json'
        }
    }).then(data => data.json());
}

const statusWireTransfer = () => {
    const token = LoginService.getUserToken();

    let headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'token': token,
        'cache-control': 'no-cache',
        'Content-Type': 'application/json',
    }

    if (jumboQAtransbank) {
        Object.assign(headers, {'x-consumer': 'jumboQA'})
    }
    return fetch(api.wallet + `/wiretransfer/status`, {
        headers,
        method: 'GET'
    }).then(data => data.json());
}


const WireTransferService = {
    getAccount,
    deleteAccount,
    addAccount,
    listBank,
    statusWireTransfer
}

export default WireTransferService;
